<div class="timesheet-column--status"></div>
<div class="timesheet-column--start"></div>
<div class="timesheet-column--end"></div>
@if (cols()?.break) {
  <div class="timesheet-column--break"></div>
}
@if (cols()?.paidBreak) {
  <div class="timesheet-column--paid-break"></div>
}
@if (cols()?.location) {
  <div class="timesheet-column--location"></div>
}
@if (cols()?.department) {
  <div class="timesheet-column--department"></div>
}
@if (cols()?.team) {
  <div class="timesheet-column--team"></div>
}
@if (cols()?.shift) {
  <div class="timesheet-column--shift"></div>
}
@if (cols()?.surcharge) {
  <div class="timesheet-column--surcharge"></div>
}
@if (cols()?.km) {
  <div class="timesheet-column--km"></div>
}
@if (cols()?.meals) {
  <div class="timesheet-column--meals"></div>
}
@if (cols()?.note) {
  <div class="timesheet-column--note"></div>
}
@for (customField of customFields(); track customField.id) {
  @if (customFieldCols()?.[customField.id]) {
    <div [style.width.px]="customField.width"></div>
  }
}
<div class="timesheet-column--details"></div>
